/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEaseIn = createReactComponent("outline", "ease-in", "IconEaseIn", [["path", { "d": "M3 20c8 0 18 -16 18 -16", "key": "svg-0" }]]);

export { IconEaseIn as default };
//# sourceMappingURL=IconEaseIn.mjs.map
